// Lib
import Immutable from 'immutable';

// Utils
import { asObject } from '../../../common/utils/immutableHelper';
import {
    getContent,
    getElementId,
    getElementLocation,
    getElementType,
} from '../../../common/elements/utils/elementPropertyUtils';
import { getElementTypeTranslationKey } from '../../../common/utils/i18n/coreTranslationHelpers';

export const getRenderedCloneElement = (cloneElement, linkedElement) => {
    const linkedElementObject = asObject(linkedElement);
    const cloneElementObject = asObject(cloneElement);

    const location = getElementLocation(cloneElementObject);

    const cloneContent = getContent(cloneElementObject);
    const linkedContent = getContent(linkedElementObject);

    const elementId = getElementId(cloneElement);

    return Immutable.fromJS({
        ...cloneElementObject,
        ...linkedElementObject,
        _id: elementId,
        id: elementId,
        isClone: true,
        location,
        content: {
            ...linkedContent,
            ...cloneContent,
        },
    });
};

export const getCloneDescription = (element, linkedElementsCount, translate) => {
    const elementType = getElementTypeTranslationKey(getElementType(element));
    const translatedElementType = translate(`elementTypes.${elementType}.${elementType}`, { count: 1 });

    // Try to get locale-specific context prefix (e.g., "of this", "de esta", "de este")
    // For gender agreement in Romance languages
    const contextPrefix = translate(`elementTypes.${elementType}.this`, { count: 1 });
    const contextPrefixKey = `elementTypes.${elementType}.this`;
    // If translation exists (not just returning the key), combine prefix with element name
    const thisElementType =
        contextPrefix !== contextPrefixKey ? `${contextPrefix} ${translatedElementType}` : translatedElementType;

    return translate('elementTypes.clone.instances.description', {
        count: linkedElementsCount,
        elementType: translatedElementType,
        thisElementType,
    });
};
